import request from '@/utils/request';

export function handleListApi(data) {
  return request({
    url: '/admin/work_sn',
    method: 'get',
    params: data,
  });
}

export function handleCreateStoreApi(data) {
  if (data.id) {
    return request({
      url: '/admin/work_sn/' + data.id,
      method: 'put',
      data,
    });
  } else {
    return request({
      url: '/admin/work_sn',
      method: 'post',
      data,
    });
  }
}

export function handleDeleteApi(data) {
  return request({
    url: '/admin/work_sn/' + data.id,
    method: 'delete',
  });
}

export function handleGetSelectApi() {
  return request({
    url: '/admin/get_work_select',
    method: 'get',
  });
}

export function handleGetQualitySelectApi(data) {
  return request({
    url: '/admin/get_work_select',
    method: 'get',
    params: data,
  });
}

export function handleAddDealApi(id) {
  return request({
    url: '/admin/work_add_deal?id=' + id,
    method: 'get',
  });
}

export function handleDelDealApi(id) {
  return request({
    url: '/admin/work_del_deal?id=' + id,
    method: 'get',
  });
}

export function handleAddLogApi(data) {
  return request({
    url: '/admin/work_add_log',
    method: 'post',
    params: data,
  });
}

export function handleWithdrawApi(work_sn) {
  return request({
    url: '/admin/work_withdraw?work_sn=' + work_sn,
    method: 'get',
  });
}

export function handleLogDataApi(data) {
  return request({
    url: '/admin/work_log',
    method: 'get',
    params: data,
  });
}

// 工单管理-工单列表-添加自助工单后台备注
export function addAdminRemark(data) {
  return request({
    url: '/admin/add_admin_remark/' + data.id,
    method: 'post',
    params: data,
  });
}

// 回复
// 批量回复
export function lotReply(data) {
  return request({
    url: '/admin/batch_reply',
    method: 'post',
    params: data,
  });
}

// 获取不分页快捷回复
export function fastReplyList(data) {
  return request({
    url: '/admin/get_fast_reply_list',
    method: 'get',
    params: data,
  });
}

// 获取分页快捷回复
export function fastReply(data) {
  return request({
    url: '/admin/fast_reply',
    method: 'get',
    params: data,
  });
}

// 新增回复
export function addReply(data) {
  return request({
    url: '/admin/fast_reply',
    method: 'post',
    params: data,
  });
}

// 查看弹窗
export function judgeModify(data) {
  return request({
    url: '/admin/check_worksn_temp',
    method: 'get',
    params: data,
  });
}
// 确认查看
export function ensureWorksnOperation(data) {
  return request({
    url: '/admin/ensure_worksn_operation',
    method: 'post',
    params: data,
  });
}

// 修改 获取
export function editGet(data) {
  return request({
    url: '/admin/fast_reply/' + data.id,
    method: 'get',
    params: data,
  });
}

// 修改 提交
export function editSubmit(data) {
  return request({
    url: '/admin/fast_reply/' + data.id,
    method: 'put',
    params: data,
  });
}

// 删除回复
export function deleteReply(data) {
  return request({
    url: '/admin/fast_reply/' + data.id,
    method: 'delete',
    params: data,
  });
}

//添加质检
export function addQualityApi(data) {
  return request({
    url: '/admin/add_quality_result',
    method: 'post',
    params: data,
  });
}

// faq游戏，类型修改
export function FAQGetSelectApi() {
  return request({
    url: '/admin/get_faq_select',
    method: 'get',
  });
}

// 获取单个 工单的的数据
export function getImportFAQdataApi(data) {
  return request({
    url: '/admin/get_import_faq_content',
    method: 'get',
    params: data,
  });
}

//  添加FAQ数据
export function importFAQdataApi(data) {
  return request({
    url: '/admin/import_faq_from_worksn',
    method: 'post',
    params: data,
  });
}

// 上传图片
export function workUploadApi(data) {
  return request({
    url: '/admin/work_upload_admin',
    method: 'post',
    data,
  });
}

// 删除工单
export function deleteApi(data) {
  return request({
    url: '/admin/work_sn/' + data.id,
    method: 'delete',
    data,
  });
}

//工单交接
export function handoverOrderApi(data) {
  return request({
    url: '/admin/assign_work_sn',
    method: 'put',
    params: data,
  });
}

// 工单管理-批量导出工单到excel
export function batchExportExcelWorksn(data) {
  return request({
    url: '/admin/batch_export_excel_worksn',
    method: 'post',
    data,
  });
}

// 工单管理-设置自动回复
export function setAutoReply(data) {
  return request({
    url: '/admin/set_auto_reply',
    method: 'post',
    data,
  });
}

// 工单管理-获取自动回复
export function getAutoReply() {
  return request({
    url: '/admin/get_auto_reply',
    method: 'get',
  });
}

// 工单管理-获取工单导出下拉框
export function getExportSuggestionSelect() {
  return request({
    url: '/admin/get_export_suggestion_select',
    method: 'get',
  });
}

// 工单管理-导入合服建议
export function batchExportToSuggestion(data) {
  return request({
    url: '/admin/batch_export_to_suggestion',
    method: 'post',
    data,
  });
}

// 工单管理-工单详情
export function getWorkSnDetail(id) {
  return request({
    url: `/admin/work_sn/${id}`,
    method: 'get',
  });
}

// 工单管理-历史工单
export function getHistoryList(data) {
  return request({
    url: `/admin/get_history_list`,
    method: 'get',
    params: data,
  });
}
